import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "recipientCheckbox",
    "selectAllCheckbox",
    "selectedRecipientIds",
    "actionsButton",
    "actionsTooltipWrapper",
    "convertPlayerBioLink",
    "exportCsvLink",
    "modal",
    "modalBody",
    "modalTitle",
    "modalConvertLink"
  ]

  static values = {
    formId: String,
    convertPlayerBioUrl: String,
    exportCsvUrl: String,
    recipient: String
  }

  connect() {
    // Disabled buttons don't fire hover events, so the tooltip lives on the wrapper span.
    if (this.hasActionsTooltipWrapperTarget && window.bootstrap?.Tooltip) {
      this.actionsTooltip = new window.bootstrap.Tooltip(this.actionsTooltipWrapperTarget)
    }

    this.syncSelectionState()
  }

  disconnect() {
    this.actionsTooltip?.dispose()
    this.actionsTooltip = null
  }

  toggleAllRecipients(event) {
    const checked = event.target.checked === true
    this.recipientCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = checked
    })
    this.syncSelectionState()
  }

  toggleRecipient() {
    this.syncSelectionState()
  }

  syncSelectionState() {
    const selectedIds = this.selectedRecipientIds()
    if (this.hasSelectedRecipientIdsTarget) {
      this.selectedRecipientIdsTarget.value = JSON.stringify(selectedIds)
    }

    const hasSelection = selectedIds.length > 0
    if (this.hasActionsButtonTarget) {
      this.actionsButtonTarget.disabled = !hasSelection
    }

    if (this.actionsTooltip) {
      if (hasSelection) {
        this.actionsTooltip.hide()
        this.actionsTooltip.disable()
      } else {
        this.actionsTooltip.enable()
      }
    }

    if (this.hasSelectAllCheckboxTarget) {
      const checkboxes = this.recipientCheckboxTargets
      this.selectAllCheckboxTarget.checked = checkboxes.length > 0 && checkboxes.every((checkbox) => checkbox.checked)
      this.selectAllCheckboxTarget.indeterminate = checkboxes.some((checkbox) => checkbox.checked) && !this.selectAllCheckboxTarget.checked
    }
  }

  displayResults({ params }) {
    const recipientId = params.recipient
    if (!recipientId) return

    this.recipientValue = recipientId.toString()

    if (this.hasModalBodyTarget) {
      this.modalBodyTarget.innerHTML = ""
    }

    if (this.hasModalTitleTarget) {
      const titleName = params.name || "Responses"
      this.modalTitleTarget.textContent = `Responses - ${titleName}`
    }

    if (this.hasModalConvertLinkTarget) {
      const convertUrl = new URL(this.convertPlayerBioUrlValue, window.location.origin)
      convertUrl.searchParams.append("recipient_ids[]", recipientId)
      this.modalConvertLinkTarget.href = convertUrl.toString()
    }

    fetch(`/forms/${this.formIdValue}/recipients/${recipientId}/answers`)
      .then((response) => response.text())
      .then((partial) => {
        if (!this.hasModalBodyTarget) return

        this.modalBodyTarget.innerHTML = ""
        this.modalBodyTarget.insertAdjacentHTML("beforeend", partial)
      })
  }

  openConvertPlayerBio(event) {
    event.preventDefault()
    const selectedIds = this.selectedRecipientIds()
    if (selectedIds.length === 0) {
      return
    }

    const url = new URL(this.convertPlayerBioUrlValue, window.location.origin)
    selectedIds.forEach((id) => url.searchParams.append("recipient_ids[]", id))
    window.location.href = url.toString()
  }

  openExportCsv(event) {
    event.preventDefault()
    const selectedIds = this.selectedRecipientIds()
    if (selectedIds.length === 0) {
      return
    }

    const url = new URL(this.exportCsvUrlValue, window.location.origin)
    selectedIds.forEach((id) => url.searchParams.append("recipient_ids[]", id))
    window.location.href = url.toString()
  }

  selectedRecipientIds() {
    return this.recipientCheckboxTargets.filter((checkbox) => checkbox.checked).map((checkbox) => parseInt(checkbox.value, 10))
  }
}
